module.exports = __webpack_public_path__ + "static/media/sponsor-video.6f943e6c.mp4";